import { render, staticRenderFns } from "./P1-0.vue?vue&type=template&id=5161c32e&scoped=true"
import script from "./P1-0.vue?vue&type=script&lang=js"
export * from "./P1-0.vue?vue&type=script&lang=js"
import style0 from "./P1-0.vue?vue&type=style&index=0&id=5161c32e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161c32e",
  null
  
)

export default component.exports